import { render, staticRenderFns } from "./main-banner.vue?vue&type=template&id=45c3ccdc"
import script from "./main-banner?vue&type=script&lang=ts&external"
export * from "./main-banner?vue&type=script&lang=ts&external"
import style0 from "./main-banner.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports